// extracted by mini-css-extract-plugin
export default {"suggestion":"empty-input-suggestions__suggestion___icnS_","showMore":"empty-input-suggestions__showMore___nQvnT","listSubtitle":"empty-input-suggestions__listSubtitle___tjQV7"};